import sensors from 'sa-sdk-javascript'
import { version } from '../../package.json'
import browsers from '@/utils/browser.js'

if (sensors) {
  sensors.init({
    name: 'sensors',
    server_url: 'https://sensorsdata-4.talbrain.com:8080/sa?token=schemaLimited-LvkDCYUe&project=ms_sensors_data',
    cross_subdomain: false,
    is_track_single_page: true,
    show_log: env() !== 'pro',
    heatmap: {
      // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default'
    },
    preset_properties: {
      latest_utm: true,
      latest_traffic_source_type: true,
      latest_search_keyword: true,
      latest_referrer: true,
      latest_referrer_host: true,
      latest_landing_page: true,
      url: true,
      title: true
    }
  })

  if (localStorage.getItem('loggedUser')) {
    sensorsRegister(JSON.parse(localStorage.getItem('loggedUser')), 'init')
  }

  sensors.quick('autoTrack')

  window.addEventListener('click', (e) => {
    sensors.quick('trackAllHeatMap', env(), e.target)
  })

  window.sensors = sensors
}

function env () {
  const host = window.location.host
  const hostInfo = {
    'localhost:8080': 'dev',
    'm-main-dev.mofaxiao.com': 'dev',
    'm-stage.mofaxiao.com': 'stage',
    'm-main.mofaxiao.com': 'pro'
  }
  return hostInfo[host] ? hostInfo[host] : 'dev'
}

function judgeCooperationType (cooperation_type) {
  const Institutional_model = JSON.parse(cooperation_type)
  const Institutional_model_Arr = []
  const { moby_ss, ms_ai, ms_content, ms_ms, ms_ss, wisroom_ai, zby } = Institutional_model
  if (moby_ss) {
    Institutional_model_Arr.push('自营双师')
  }
  if (ms_ai) {
    Institutional_model_Arr.push('魔法AI')
  }
  if (ms_content) {
    Institutional_model_Arr.push('好课')
  }
  if (ms_ms) {
    Institutional_model_Arr.push('面授')
  }
  if (ms_ss) {
    Institutional_model_Arr.push('双师')
  }
  if (wisroom_ai) {
    Institutional_model_Arr.push('乐外教AI')
  }
  if (zby && ms_content) {
    Institutional_model_Arr.push('课程包直播')
  }
  if (zby && (ms_ai || wisroom_ai)) {
    Institutional_model_Arr.push('AI直播')
  }
  if (zby && !ms_content && !wisroom_ai && !ms_ai) {
    Institutional_model_Arr.push('普通直播')
  }
  return Institutional_model_Arr.join()
}

export function sensorsRegister (loggedUser, from) {
  // console.log('@from@@from@@from@@from@@from@@from@@from@@from@', from)

  let host = window.location.host
  let productName = host.indexOf('mofaxiao') > 0 ? 'mofaxiao' : host.indexOf('weclassroom') > 0 ? 'weclassroom' : 'localhost'
  let browserObj = browsers()
  let browserVersion
  let browser
  // console.log('browserObj', browserObj)
  for (let attr in browserObj.browser) {
    if (browserObj.browser[attr] !== 0 && attr !== 'ver') {
      browserVersion = browserObj.browser[attr]
      browser = attr
    }
  }
  // console.log('browser', browserVersion, browser)

  let Institutional_model = judgeCooperationType(loggedUser.cooperation_type)
  // console.log('loggedUser', loggedUser)
  // console.log('Institutional_model', Institutional_model)

  sensors.login(loggedUser.id)
  sensors.setProfile({
    name: loggedUser.name,
    organization_id: loggedUser.school.id,
    Employee_type: loggedUser.staff_type === '1' ? '全职' : loggedUser.staff_type === '2' ? '专职' : '兼职', // 员工类型
    gender: loggedUser.gender === '1' ? '男' : loggedUser.gender === '2' ? '女' : '未知', // 性别
    Position_role: loggedUser.role_name, // 职位角色
    data_sources: loggedUser.is_zby_import === '1' ? '导入' : '非导入', // 数据来源
    Institutional_model: Institutional_model // 机构模式
  })

  sensors.registerPage({
    organization_id: loggedUser.school.id,
    organization_name: loggedUser.school.short_name,
    account_id: loggedUser.id,
    platForm: 'h5',
    app_name: '魔法校机构主站',
    env: env(),
    version,
    product_name: productName,
    browser: browser,
    browser_edition: browserVersion
  })
}
